export const questionsFive = [
  {
    id: 1,
    question:
      "Look at this series: 80, 10, 70, 15, 60, … What number should come next?",
    answer: "20",
    options: ["20", "25", "30", "50"],
    explanations: [
      "This is an alternating addition and subtraction series. In the first pattern, 10 is subtracted from each number to arrive at the next. In the second, 5 is added to each number to arrive at the next.",
    ],
  },
  {
    id: 2,
    question:
      "Look at this series: 2, 1, (1/2), (1/4), … What number should come next?",
    answer: "(1/8)",
    options: ["(1/3)", "(1/8)", "(2/8)", "(1/16)"],
    explanations: [
      "It's a division series. Every number is half of the previous number.",
    ],
  },
  {
    id: 3,
    question:
      "Look at this series: 7, 10, 8, 11, 9, 12, … What number should come next?",
    answer: "10",
    options: ["7", "12", "10", "13"],
    explanations: [
      "It's an alternating addition and subtraction series. 3 is added in the first pattern, and then 2 is subtracted.",
    ],
  },
  {
    id: 4,
    question:
      "Look at this series: 36, 34, 30, 28, 24, … What number should come next?",
    answer: "22",
    options: ["22", "26", "23", "20"],
    explanations: [
      "This is an alternating number of subtraction series. First, 2 is subtracted, then 4, then 2, and so on.",
    ],
  },
  {
    id: 5,
    question:
      "Look at this series: 12, 11, 13, 12, 14, 13, … What number should come next?",
    answer: "15",
    options: ["10", "16", "13", "15"],
    explanations: [
      "This is an alternating number of subtraction series. First, 1 is subtracted, then 2 is added.",
    ],
  },
  {
    id: 6,
    question: "Which word does NOT belong with the others?",
    answer: "book",
    options: ["index", "glossary", "chapter", "book"],
    explanations: ["Rest are all parts of a book."],
  },
  {
    id: 7,
    question: "Which word is the odd man out?",
    answer: "important",
    options: ["trivial", "unimportant", "important", "insignificant"],
    explanations: ["Remaining are synonyms of each other."],
  },
  {
    id: 8,
    question: "Which word does NOT belong with the others?",
    answer: "beak",
    options: ["wing", "fin", "beak", "rudder"],
    explanations: ["Rest are parts of an aeroplane."],
  },
  {
    id: 9,
    question: "Which word is the odd man out?",
    answer: "hate",
    options: ["hate", "fondness", "liking", "attachment"],
    explanations: ["Rest are positive emotions."],
  },
  {
    id: 10,
    question: "Pick the odd man out?",
    answer: "biased",
    options: ["just", "fair", "equitable", "biased"],
    explanations: ["The others signify honesty."],
  },
  {
    id: 11,
    question:
      "If ROSE is coded as 6821, CHAIR is coded as 73456 and PREACH is coded as 961473, what will be the code for SEARCH? ",
    answer: "214673",
    options: ["216473", "246173", "214673", "214763"],
    explanations: [
      "The letters are coded accordingly S as 2, E as 1, A as 4, R as 6, C as 7, and H as 3. i.e., 214673",
    ],
  },
  {
    id: 12,
    question:
      "If in a certain code, GLAMOUR is written as IJCNMWP and MISRULE are written as OGUSSNC, then how will TOPICAL be written in that code? ",
    answer: "VMRJACJ",
    options: ["VMRJECN", "VMRHAGJ", "VMRJACJ", "VNRJABJ"],
    explanations: [
      "The first, third and sixth letters of the word are each moved two steps forward, the second, fifth and seventh letters are each are moved two steps backward, while the fourth letter is moved one step forward.",
    ],
  },
  {
    id: 13,
    question:
      "If TRANSFER is coded as RTNAFSRE, then ELEPHANT would be coded as ",
    answer: "LEPEAHTN",
    options: ["LEPEHATN", "LEPEAHTN", "LEEPAHTN", " LEPEAHNT"],
    explanations: ["The letters are reversed in pairs."],
  },
  {
    id: 14,
    question:
      "If in a code language, COULD is written as BNTKC and MARGIN is written as LZQFHM, how will MOULDING be written in that code? ",
    answer: "LNTKCHMF",
    options: ["NITKHCMF", "CHMFINTK", "LNKTCHMF", "LNTKCHMF"],
    explanations: [
      "Each letter in the word is moved one step backward to obtain the corresponding letter of the code",
    ],
  },
  {
    id: 15,
    question:
      "In 18 minutes, how much do the minutes gains over the hour hand?",
    answer: "99°",
    options: ["80°", "90°", "99°", "105°"],
    explanations: [
      "In an hour, the minute hand gains 330° space over the hour hand which equals 60 minutes. Thus in 18 minutes, it gains 330°/60 x 18 = 99°.",
    ],
  },
  {
    id: 16,
    question:
      "Between 8.15 and 7.15 when will the hand of the clock coincide with each other?",
    answer: "45",
    options: ["30", "40", "45", "60"],
    explanations: [
      "The formula to solve these type of questions is 60/11 x n. Here n = 8.15 = 8 15/60 = 33/4. Thus 60/11 x 33/4 = 45.",
    ],
  },
  {
    id: 17,
    question:
      "A told B that C is his father's nephew. D is A's cousin but not the brother of C. What relationship is there between D and C ? ",
    answer: "Sisters",
    options: ["Father", "Sisters", "Aunt", "Mother"],
    explanations: [
      "A has two cousins C and D. Since C is male, D must be female. And, both are the nephew and niece of A's father.",
    ],
  },
  {
    id: 18,
    question:
      "Pointing towards a person, a man said to a woman, “His mother is the only daughter of your father.” How is the woman related to that person?",
    answer: "Mother",
    options: ["Sister", "Daughter", "Mother", "Wife"],
    explanations: [
      "The only daughter of woman's father is herself. So, the person is the woman's son. i.e., the woman is the person's mother.",
    ],
  },
  {
    id: 19,
    question:
      "Pointing out to a girl a man said 'My uncle is the uncle of this girl's uncle'. How is the man related to that girl? ",
    answer: "Father",
    options: ["Cousin", "Brother", "Father in law", "Father"],
    explanations: [
      "The man's uncle and the uncle of the girl's uncle are the same people. So he may be the father or uncle of the girl.",
    ],
  },
  {
    id: 20,
    question:
      "If S is the brother of N, the sister of N is M, the brother of P is J and the daughter of S is P then who is the uncle of J? ",
    answer: "Russia",
    options: ["J", "S", "P", "M"],
    explanations: [
      "As J and P are real brothers and their father is S whose brother is N, so N is the uncle of J and P.",
    ],
  },
  {
    id: 21,
    question: "India will lead in various sports by 2030.",
    answer: "Probable",
    options: ["True", "False", "Probable", "Absurd"],
    explanations: ["Future can't be determined."],
  },
  {
    id: 22,
    question: "Donald duck was a famous duck named after Donald Trump.",
    answer: "Absurd",
    options: ["True", "False", "Probable", "Absurd"],
    explanations: ["The sentence has no logic."],
  },
  {
    id: 23,
    question: "India is the seventh largest country in the world.",
    answer: "True",
    options: ["True", "False", "Probable", "Absurd"],
    explanations: [
      "India is the seventh-largest country in the world followed by Russia, Canada, China, USA, Brazil, and Australia.",
    ],
  },
  {
    id: 24,
    question: "President of India is elected by the people.",
    answer: "False",
    options: ["True", "False", "Probable", "Absurd"],
    explanations: [
      "The president is indirectly elected by an electoral college comprising both houses of the Parliament of India",
    ],
  },
  {
    id: 25,
    question: "Light travels faster tham sound.",
    answer: "True",
    options: ["True", "False", "Probable", "Absurd"],
    explanations: [
      "The speed of light as it travels through air and space is much faster than that of sound",
    ],
  },

  {
    id: 26,
    question:
      "Rearrange the letters in capitals : EETPNRSS is a synonym of snakes.",
    answer: "SERPENTS",
    options: ["SERPENTS", "PRESENTS", "REPENTSS", "PERTNESS"],
    explanations: [
      "Three of the options are genuine words: PERTNESS (impudence or cheek), PRESENTS, and SERPENTS. However, the only one which makes sense in the sentence is SERPENTS so that must be the correct answer",
    ],
  },
  {
    id: 27,
    question:
      "Rearrange the letters in capitals : Jets can travel at PICEROSSUN speeds.",
    answer: "SUPERSONIC",
    options: ["SCOURPINES", "PERCUSSION", "CONIPURESS", "SUPERSONIC"],
    explanations: [
      "SUPERSONIC is the only option that would make sense in the sentence, so is the correct answer",
    ],
  },
  {
    id: 28,
    question:
      "Rearrange the letters in capitals : He could not walk fast due to his NESSMALE.",
    answer: "LAMENESS",
    options: ["LAMENESS", "SALESMAN", "MALENESS", "NAMELESS"],
    explanations: [
      "NAMELESS (without a name), SALESMAN (one who sells things for a living), MALENESS (masculinity), and LAMENESS (disability in the foot or leg). Masculinity does not affect one’s ability to walk and neither SALESMAN nor NAMELESS makes sense in the sentence. The correct answer is LAMENESS",
    ],
  },

  {
    id: 29,
    question:
      "Rearrange the letters in capitals : The polar bear is the largest TROPERAD.",
    answer: "PREDATOR",
    options: ["TEARDROP", "PARDOTER", "PREDATOR", "PARROTED"],
    explanations: [
      "The correct answer must be PREDATOR as none of the other options makes sense",
    ],
  },
  {
    id: 30,
    question:
      "Rearrange the letters in capitals : Mirages are a kind of ACTLPOI illusion.",
    answer: "OPTICAL",
    options: ["TOPICAL", "OPTICAL", "CAPITOL", "LOPCAIT"],
    explanations: [
      "LOPCAIT is not a word so the answer must be TOPICAL (relevant to current events), CAPITOL (the building in which the US Congress meets), or OPTICAL (to do with sight). The only one of these which works in the sentence is OPTICAL",
    ],
  },
  {
    id: 31,
    question: "Microphone : Loud :: Microscope : ?",
    answer: "Magnify",
    options: ["Elongate", "Investigate", "Magnify", "Examine"],
    explanations: [
      "As Microphone makes the sound louder similarly Microscope makes the object magnified.",
    ],
  },
  {
    id: 32,
    question: "Melt : Liquid :: Freeze : ?",
    answer: "Solid",
    options: ["Ice", "Condense", "Solid", "Force"],
    explanations: [
      "As on melting, the liquid is formed similarly on freezing solid is formed.",
    ],
  },
  {
    id: 33,
    question: "Tree : Forest :: Grass : ?",
    answer: "Lawn",
    options: ["Lawn", "Garden", "Park", "Field"],
    explanations: [
      "As Tree is found in Forest similarly Grass is found in Lawn.",
    ],
  },
  {
    id: 34,
    question: "South : North-West :: West : ?",
    answer: "North-East",
    options: ["North", "South-West", "North-East", "East"],
    explanations: [
      "As North-West is 135 degree clockwise from South in the same were North-East is 135 degree clockwise from the West.",
    ],
  },
  {
    id: 35,
    question: "Country : President :: State : ?",
    answer: "Governor",
    options: ["Governor", "M.P", "Legislator", "Minister"],
    explanations: [
      "As President is the nominal head of a country, similarly Governor is the nominal head of a State.",
    ],
  },
  {
    id: 36,
    question: "A mirror always",
    answer: "Reflects",
    options: ["Retracts", "Distorts", "Refracts", "Reflects"],
    explanations: [
      "Mirror is always used for showing the reflection of the object or person in front of it.",
    ],
  },
  {
    id: 37,
    question:
      "In India a widow can marry her brother-in-law although a man cannot marry the sister of his dead wife:",
    answer: "Sometimes",
    options: ["Always", "Never", "Often", "Sometimes"],
    explanations: [
      "As there is no such tradition hence this will happen sometimes.",
    ],
  },
  {
    id: 38,
    question:
      "If in each number, the first and the last digit are interchanged, which of the following will be the second highest number?",
    answer: "654",
    options: ["489", "541", "654", "953"],
    explanations: [
      "After interchanging the first and the last digit, numbers are 984, 145, 456, 359, 387 Hence, second-highest number = 456 means 654.",
    ],
  },
  {
    id: 39,
    question:
      "If in each number, all the three digits are arranged in ascending order, which of the following will be the lowest number?",
    answer: "541",
    options: ["489", "541", "654", "953"],
    explanations: [
      "Arranging all the digits in ascending order, we get 489, 145, 456, 359, 378 Hence, lowest number = 145 ⇒ 541",
    ],
  },
  {
    id: 40,
    question:
      "If each of the digits in the number 92581473 is arranged in ascending order, what will be the difference between the digits, which are fourth from the right and third from the left in the new arrangement?",
    answer: "Two",
    options: ["One", "Two", "Three", "Four"],
    explanations: [
      "Ascending order 1 2 3 4 5 7 8 9 ∴ Required difference = 5 - 3 = 2",
    ],
  },
];
